export function stickyFilters(calendarFiltersContainer: HTMLElement, topNavHeight: number, accordionToToggle: HTMLElement, functionToRun: Function) {
    const filtersHeight = calendarFiltersContainer.getBoundingClientRect().height;
    const stick = (calendarFiltersContainer.getBoundingClientRect().top <= topNavHeight) ? true : false;
    const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (windowWidth > 1024) {
        if (stick) {
            const accordionAriaHidden = accordionToToggle.getAttribute('aria-hidden');
            if (accordionAriaHidden != null && accordionAriaHidden === 'false') {
                functionToRun();
            }
            calendarFiltersContainer.style.height = `${filtersHeight}px`;
        }
        else {
            calendarFiltersContainer.removeAttribute('style');
        }
        return stick;
    }
    else
        return;
}